import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"button-window__window\">\n  {{yield}}\n</div>\n<button class=\"button button-window__button {{this.buttonClass}}\" disabled={{this.disabled}}>\n  {{this.label}}\n</button>", {
  moduleName: "@dashboard/shared-ui/components/sq-button-window.hbs"
});